import {useMediaQuery} from "@mui/material";

export const useResponsive = () => {
    const isMobile = useMediaQuery('(max-width:770px)');
    const isTablet = useMediaQuery('(max-width:1200px)');
    return {isMobile, isTablet, isDesktop: !isMobile && !isTablet};
}
